import IntervalTimer from './components/IntervalTimer';

export default IntervalTimer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-interval-timer/es/index.js
// module id = 717
// module chunks = 1 2